/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const elevenlabsQuotaV1DataSchema = z.object({
  tier: z.string().nullable(),
  status: z.string().nullable(),
  characterCount: z.number(),
  characterLimit: z.number(),
  nextCharacterCountResetUnix: z.number().nullable(),
  voiceLimit: z.number().nullable(),
  voiceCount: z.number().nullable(),
  canExtendCharacterLimit: z.boolean().nullable(),
});

export type IElevenlabsQuotaV1Data = z.infer<typeof elevenlabsQuotaV1DataSchema>;

export const getElevenlabsQuotaV1ResponseSchema = createApiResponseSchema(
  elevenlabsQuotaV1DataSchema,
) as z.ZodSchema<IAPI<IElevenlabsQuotaV1Data>>;

export type IGetElevenlabsQuotaV1Response = IAPI<IElevenlabsQuotaV1Data>;
